import React from "react";

const HowRatingsWork = () => {
    return (
        <div className="mt-10 w-full max-w-[1100px] mx-auto mb-10">
            <h4 className="font-semibold mb-3 text-lg">
                How the Rating Works
            </h4>
            <p className='text-xs text-custom-light-grey leading-relaxed'>
                The surf spot rating system measures how closely current conditions match your ideal preferences on a scale of 0 to 5 stars. Each condition is evaluated with graduated tolerance levels for realistic scoring:
            </p>
            <ul className='text-xs text-custom-light-grey leading-relaxed mt-3 space-y-2 list-disc pl-5'>
                <li>
                    <strong className="text-white">Wave Height</strong> (max 3 points): Full points within your ideal range, 2 points if ±0.2m outside, 1 point if ±0.4m outside.
                </li>
                <li>
                    <strong className="text-white">Swell Period</strong> (max 3 points): Full points within ideal range, 2 points if ±1 second outside, 1 point if ±2 seconds outside. However, if swell direction is more than 45° off your preference, the period score is heavily penalized as poor direction negates good period.
                </li>
                <li>
                    <strong className="text-white">Swell Direction</strong> (max 3 points): 3 points for within 5°, 2 points for within 20°, 1 point for within 45° of your ideal direction.
                </li>
                <li>
                    <strong className="text-white">Wind Speed</strong> (max 3 points): Full points within your ideal range, 2 points if ±2 km/h outside, 1 point if ±5 km/h outside. However, if wind direction is more than 95° off your preference, the speed score is heavily penalized as cross/onshore winds negate ideal wind speed.
                </li>
                <li>
                    <strong className="text-white">Wind Direction</strong> (max 3 points): Full points when wind speed is low (≤8 km/h) or direction is within 20° of ideal, 2 points for within 45°, 1 point for within 80°.
                </li>
            </ul>
            <p className='text-xs text-custom-light-grey leading-relaxed mt-3'>
                The total points (maximum 15) are converted to a 5-star rating, giving you an instant visual indicator of how well the forecast conditions align with your perfect surf session. The more stars, the closer the conditions are to your ideal setup!
            </p>
        </div>
    )
}

export default HowRatingsWork;